const pinkPurple = {
  color: '#FFFFFF',
  background: '#390099',
  block: {
    normal: '#FF8FA3',
    hover: '#FFB3C1',
    active: '#fa506f'
  },
  chess: '#FFFFFF',
  restartButton: {
    normal: '#FFBD00',
    hover: '#FFC933',
    active: '#FFBE0A'
  },
  switchButton: {
    on: '#FF758F',
    off: '#a5a5a5'
  }
};

const rainbow = {
  color: '#FFFFFC',
  background: '#FFC6FF',
  block: {
    normal: '#9BF6FF',
    hover: '#A0C4FF',
    active: '#CAFFBF'
  },
  chess: '#FFFFFC',
  restartButton: {
    normal: '#FFD6A5',
    hover: '#FDFFB6',
    active: '#FFADAD'
  },
  switchButton: {
    on: '#9BF6FF',
    off: '#a5a5a5'
  }
};

export default {
  default: pinkPurple,
  rainbow
};